
import { Container, Stack, Unstable_Grid2 as Grid } from '@mui/material';
import { Layout as DashboardLayout } from './layout'
import { AccountProfileDetails } from './account-profile-details';

import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Typography
} from '@mui/material';
import Iconify from '../../common/Iconify/Iconify';
import SignatorySubscribe from './SignatorySubscribe'


import React, { useState, useEffect, useContext } from "react";
import {Link, useNavigate} from 'react-router-dom';
import { UserContext } from "../../context/UserContext";
import { BASE_URL } from "../../baseUrl"


const UserProfile = () => {

  const [login, setLogin] = useContext(UserContext);
  const isLoggedIn = login.isLoggedIn;
  const [loaded, setLoaded] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [UserBio, setUserBio] = useState("");
  const [Commitments, setCommitments] = useState([]);
  const [activeModal, setActiveModal] = useState(false);
  const [activeModalBio, setActiveModalBio] = useState(false);
  const [idstrategy, setIdStrategy] = useState(null);
  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const [modalflag, setModalFlag]= useState(null);
  const navigate = useNavigate();

  const getProfile = async ()=>{
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + login.token,
        },
    };
    
    const response = await fetch(BASE_URL + "/api/user/profile", requestOptions);
        if (!response.ok) {
            setErrorMessage("Something went wrong. Couldn't load the profile data");
        } else {
            const data = await response.json();
            console.log("********")
            console.log(data)
            setUserBio(data);
            /*setCommitments(data.commitments);*/
            setLoaded(true);
        }

  }
  
  const handleModalBio = () => {
    setActiveModalBio(!activeModalBio)
    getProfile()
  };

  useEffect(() => {
    //This code helps to scroll to the top when the screen is open
    window.scrollTo(0, 0);
    console.log("valor de ID_user")
    console.log(login.id_user)
    getProfile()
  }, []);

  return(
    <>


      {/* Profile layout */}
      <Box component="main"  sx={{flexGrow: 1,py: 8}}>
        {/* limite para los costados - otras opciones: md */}  
        <Container maxWidth="lg">
          {/* Espacio entre los grid */}
          <Stack spacing={10}>
            <div>
              <Grid  container spacing={5} direction="column" alignItems="center">
                
                {/* Section for AccountProfileDetails */}
                <Grid item xs={12} md={6} lg={8} sx={{}}>
                  <AccountProfileDetails 
                    fullname ={UserBio.Name}
                    email={UserBio.Email}
                    category = {UserBio.Category_Name}
                    city = {UserBio.City}
                    country = {UserBio.Country}
                    signatory = {UserBio.ID_Client !== 0 && UserBio.ID_Client !== 1? UserBio.Client_Name : UserBio.ID_Corp !== 0 ? UserBio.Corp_Name : 'No signatory'}
                    datesigned = {UserBio.ID_Client !== 0 && UserBio.ID_Client !== 1? UserBio.Client_Date_Sign : UserBio.ID_Corp !== 0 ? UserBio.Corp_Date_Sign : 'No signatory'}
                    bio = {UserBio.Bio}
                    photo_url = {UserBio.photo_url}
                    id_user = {login.id_user}
                    token = {login.token}
                    email_conf = {UserBio.Email_conf}
                    handlereload = {handleModalBio}
                    account_number = {UserBio.Account}
                    />
                </Grid>



                {/* Grid Object to become as a signatory */}
                <Grid xs={12} md={6} lg={4}>
                {(UserBio.Category_Name === "Guest" || UserBio.Category_Name === "Corporate") && <SignatorySubscribe token={login.token} userid={login.id_user} />}
                </Grid>

              </Grid>
            </div>
          </Stack>
        </Container>

      </Box>
    </>
  );
}

UserProfile.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);
  
export default UserProfile;